/* eslint-disable @typescript-eslint/no-explicit-any */
import { forwardRef, memo } from "react"; // Import forwardRef
import { Control, useController } from "react-hook-form";
import Textarea from "../Textarea";

export interface CustomTextareaProps {
  label?: string;
  name: string;
  control: Control<any>;
  isRequired?: boolean;
  placeholder?: string;
  characterLimit?: number;
}

const CustomTextareaInner = forwardRef<
  HTMLTextAreaElement,
  CustomTextareaProps
>((props, ref) => {
  const {
    label,
    name,
    control,
    isRequired = false,
    placeholder,
    characterLimit,
  } = props;

  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController({ name, control });

  return (
    <Textarea
      ref={ref}
      name={name}
      placeholder={placeholder}
      value={value ?? ""}
      formLabel={label}
      isRequired={isRequired}
      characterLimit={characterLimit}
      onInputChange={(e) => {
        onChange(e);
      }}
      hasError={!!error}
      errorMessage={error?.message}
    />
  );
});

// display name for easier debugging
CustomTextareaInner.displayName = "CustomTextarea";
export const CustomTextarea = memo(CustomTextareaInner);
